import { Typography } from "@mui/material"
import React from "react"
import { FlexBox } from "./FlexBox"

interface IInfoRowProps {
  title: string
  value: string | number | JSX.Element
  id?: string
  vertical?: boolean
  sx?: any
}

export const InfoRow = React.memo(({ title, value, id, vertical, sx }: IInfoRowProps) => (
  <FlexBox vertical={vertical} gap id={id} sx={sx} className="info-row">
    <Typography
      id={id ? `${id}-label` : undefined}
      color="textPrimary"
      fontSize=".9rem"
      sx={{ width: vertical ? undefined : "12rem" }}
      className="info-row-title">
      {title}
    </Typography>
    <Typography id={id ? `${id}-value` : undefined} color="textSecondary" fontSize=".85rem" className="info-row-value">
      {value}
    </Typography>
  </FlexBox>
))
